<template>
  <SectionLoader :is-loading="projectUrl.length == 0">
    <iframe
      width="100%"
      :height="height"
      :src="projectUrl"
      frameborder="0"
    ></iframe>
  </SectionLoader>
</template>

<script>
import SectionLoader from "../components//SectionLoader";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ProjectPage",
  components: {
    SectionLoader,
  },
  computed: {
    ...mapGetters("galleryProjects/", ["PROJECTS_LIST"]),
    height() {
      return window.innerHeight;
    },
    projectUrl() {
      let projectUrl = "";
      this.PROJECTS_LIST.forEach((project) => {
        if (project.id == this.$route.params.id) {
          projectUrl = project.url;
        }
      });
      return projectUrl;
    },
  },
  methods: {
    ...mapActions("galleryProjects/", ["GET_PROJECTS"]),
  },
  created() {
    if (this.$route.params.id !== undefined && this.PROJECTS_LIST.length == 0) {
      this.GET_PROJECTS();
    }
  },
};
</script>

<style></style>
